import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {
    Chip,
    Card,
    Grid,
    Badge,
    Box,
    Tabs,
    Tab,
    useTheme,
    IconButton,
    Typography,
    Button,
    Dialog,
    Divider,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    LinearProgress,
} from "@mui/material";
import { isMobile } from "react-device-detect";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { patchUnplannedMaintenanceOfTheReports, postUnplannedMaintenanceOfTheReports, closeUnPlannedMaintenance, closeManyUnplannedTasks } from "../../store/actions/breakDownDetailActions";
import { getUnPlannedMaintenanceListMultiple, getReasonGroup } from "../../store/actions/breakDownTasksActions";
import { getPlannedMaintenanceListMultiple, closeManyPlannedTasks, getList, getPoolByAssignedUser } from "../../store/actions/PlannedMaintenanceListActions";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FcInfo } from "react-icons/fc";
import { HighlightOffRounded, CheckCircleOutlineRounded, DoneAll, RemoveDone, Timelapse, TimerOutlined, WorkOutline, WorkHistory, Work, OfflinePin, CheckBox, ArrowDropUp } from "@mui/icons-material";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";
import DetailFilter from "../../components/DetailFilter/DetailFilter";
import { getShifts } from "../../store/actions/ShiftActions";
import { getMaintenanceType } from "../../store/actions/PMActions";
import { getTechnicianList } from "../../store/actions/userActions";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollTop from "react-scrolltop-button";
import moment from "moment";

//set priority text color
const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF",
        fontSize: "12px",
    },
})(Typography);

const separatorTitleStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 80,
    marginLeft: 30,
    top: "50%",
    transform: "translateY(-50%)",
    backgroundColor: "white",
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Typography component="div" role="tabpanel" hidden={value !== index} id={`scrollable-auto-tabpanel-${index}`} aria-labelledby={`scrollable-auto-tab-${index}`} {...other}>
            <Box>{children}</Box>
        </Typography>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const ss = sessionStorage;

export default function TabsPageExample() {
    const [value, setValue] = useState(0);
    const [mainValue, setMainValue] = useState(ss.getItem("ap_selectedTab") !== null ? parseInt(ss.getItem("ap_selectedTab")) : 0);
    const [valueTasks, setValueTasks] = useState(ss.getItem("ap_selectedTab") !== null ? parseInt(ss.getItem("ap_selectedTabTasks")) : 0);
    const [rows, setRows] = useState([]);
    const [count, setCount] = useState(0);
    const [poolData, setPoolData] = useState([]);
    const [poolDataByAssignedUser, setPoolDataByAssignedUser] = useState([]);
    const [poolIds, setPoolIds] = useState([]);
    const [breakdownReasonGroupIds, setBreakdownReasonGroupIds] = useState([]);
    const [breakdownReasonGroupData, setBreakdownReasonGroupData] = useState([]);
    const [startDate, setStartDate] = useState(new Date().getFullYear() - 1 + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate());
    const [shiftIds, setShiftIds] = useState([]);
    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [userData, setUserData] = useState([]);
    const [userIds, setUserIds] = useState([]);
    const [userName, setUserName] = useState("");

    let history = useHistory();
    const theme = useTheme();
    const dispatch = useDispatch();
    const { t } = useTranslation("translation");

    useEffect(() => {
        getReportList();
        dispatch(getTechnicianList());
    }, []);

    const {
        user: { technicianList },
    } = useSelector((user) => user);

    useEffect(() => {
        if (technicianList) {
            setUserData(technicianList);
        }
    }, [technicianList]);

    const getReportList = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        const payload = {
            pageNumber: pageNumber + 1,
            pageSize: pageSize,
            body: {
                reportStatuses: [value],
                sorting: {
                    propertyName: "id",
                    direction: 1,
                },
                areaId: parseInt(ss.getItem("ap_selectedAreaCode") ?? 0) ?? 0,
                machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
                poolIds: poolIds,
                assigneeIds: userIds || [],
            },
            firstCall: true,
        };
        dispatch(postUnplannedMaintenanceOfTheReports(payload));
    };

    const getBreakdownTasks = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        const data = {
            statusArr: [5].toString(),
            assigneedIds: [],
            creatorIds: [],
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(new Date()).format("YYYY-MM-DD"),
            breakdownGroupIds: breakdownReasonGroupIds,
            poolIds: poolIds,
            costCenterIds: [],
            breakdownEffectIds: [],
            areaGroupIds: [],
            shifts: shiftIds,
        };
        let payload = {
            data: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize,
            firstCall: true,
        };
        dispatch(getUnPlannedMaintenanceListMultiple(payload));
    };

    const getPlannedTasks = (pageNumber = currentPage, pageSize = rowsPerPage) => {
        const data = {
            statusArr: [5].toString(),
            assigneedIds: [],
            creatorIds: [],
            startDate: moment(startDate).format("YYYY-MM-DD"),
            endDate: moment(new Date()).format("YYYY-MM-DD"),
            maintenanceTypeIds: selectedMaintenanceTypeIds,
            poolIds: poolIds,
            costCenterIds: [],
            areaGroupIds: [],
            shifts: shiftIds,
            sorting: {
                propertyName: "id",
                direction: 1,
            },
        };
        let payload = {
            data: data,
            currentPage: pageNumber + 1,
            pageSize: pageSize,
            firstCall: true,
        };
        dispatch(getPlannedMaintenanceListMultiple(payload));
    };

    const FetchMoreData = () => {
        if (mainValue === 0) {
            const payload = {
                pageNumber: currentPage + 2,
                pageSize: rowsPerPage,
                body: {
                    reportStatuses: [value],
                    sorting: {
                        propertyName: "id",
                        direction: 1,
                    },
                    areaId: parseInt(ss.getItem("ap_selectedAreaCode") ?? 0) ?? 0,
                    machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
                    poolIds: poolIds,
                    assigneeIds: userIds || [],
                },
                fetchMoreData: true,
            };
            dispatch(postUnplannedMaintenanceOfTheReports(payload));
        } else if (mainValue === 1) {
            if (valueTasks === 0) {
                const data = {
                    statusArr: [5].toString(),
                    assigneedIds: [],
                    creatorIds: [],
                    startDate: moment(startDate).format("YYYY-MM-DD"),
                    endDate: moment(new Date()).format("YYYY-MM-DD"),
                    breakdownGroupIds: breakdownReasonGroupIds,
                    poolIds: poolIds,
                    costCenterIds: [],
                    breakdownEffectIds: [],
                    areaGroupIds: [],
                    shifts: shiftIds,
                };

                let payload = {
                    data: data,
                    currentPage: currentPage + 2,
                    pageSize: rowsPerPage,
                    fetchMoreData: true,
                };

                dispatch(getUnPlannedMaintenanceListMultiple(payload));
            } else if (valueTasks === 1) {
                const data = {
                    statusArr: [5].toString(),
                    assigneedIds: [],
                    creatorIds: [],
                    startDate: moment(startDate).format("YYYY-MM-DD"),
                    endDate: moment(new Date()).format("YYYY-MM-DD"),
                    maintenanceTypeIds: selectedMaintenanceTypeIds,
                    poolIds: poolIds,
                    costCenterIds: [],
                    areaGroupIds: [],
                    shifts: shiftIds,
                    sorting: {
                        propertyName: "id",
                        direction: 1,
                    },
                };

                let payload = {
                    data: data,
                    currentPage: currentPage + 2,
                    pageSize: rowsPerPage,
                    fetchMoreData: true,
                };

                dispatch(getPlannedMaintenanceListMultiple(payload));
            }
        }
    };

    const { setListUnPMReportsByStatus, updateReportList, isTaskUpdated } = useSelector(({ breakDownDetail }) => breakDownDetail);
    useEffect(() => {
        if (setListUnPMReportsByStatus?.firstCallRes) {
            setRows(Object.values(setListUnPMReportsByStatus.firstCallRes.resultObject.content));
            setCount(setListUnPMReportsByStatus.firstCallRes.resultObject.totalCount);
            setHasMore(setListUnPMReportsByStatus.firstCallRes.resultObject.hasNext);
        }

        if (setListUnPMReportsByStatus?.fetchMoreDataRes) {
            const totalRows = [...rows, ...setListUnPMReportsByStatus.fetchMoreDataRes.resultObject.content];
            setRows(totalRows);
            setCount(setListUnPMReportsByStatus.fetchMoreDataRes.resultObject.totalCount);

            const hasNextPage = setListUnPMReportsByStatus.fetchMoreDataRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(currentPage + 1);
            }
        }
        if (updateReportList) {
            getReportList();
        }
        if (isTaskUpdated) {
            getBreakdownTasks();
        }
    }, [setListUnPMReportsByStatus, updateReportList, isTaskUpdated]);

    const { unPlannedMaintenance, reasonGroup } = useSelector(({ breakDownTask }) => breakDownTask);

    useEffect(() => {
        if (unPlannedMaintenance?.firstCallRes) {
            setRows(Object.values(unPlannedMaintenance.firstCallRes.resultObject.content));
            setCount(unPlannedMaintenance.firstCallRes.resultObject.totalCount);
            setHasMore(unPlannedMaintenance.firstCallRes.resultObject.hasNext);
        }
        if (unPlannedMaintenance?.fetchMoreDataRes) {
            const totalRows = [...rows, ...unPlannedMaintenance.fetchMoreDataRes.resultObject.content];
            setRows(totalRows);

            const hasNextPage = unPlannedMaintenance.fetchMoreDataRes.resultObject.hasNext;
            setHasMore(hasNextPage);
            if (hasNextPage) {
                setCurrentPage(currentPage + 1);
            }
        }
    }, [unPlannedMaintenance]);

    useEffect(() => {
        if (reasonGroup?.resultObject) {
            setBreakdownReasonGroupData(Object.values(reasonGroup.resultObject));
        }
    }, [reasonGroup]);

    const PlannedMaintenanceList = useSelector((pmlState) => pmlState.PlannedMaintenanceList);
    useEffect(() => {
        if (PlannedMaintenanceList.taskListMultiple?.firstCallRes) {
            setRows(PlannedMaintenanceList.taskListMultiple.firstCallRes.resultObject.content);
            setCount(PlannedMaintenanceList.taskListMultiple.firstCallRes.resultObject.totalCount);
            setHasMore(PlannedMaintenanceList.taskListMultiple.firstCallRes.resultObject.hasNext);
        }
    }, [PlannedMaintenanceList.taskListMultiple]);

    useEffect(() => {
        if (PlannedMaintenanceList?.isTaskUpdated) {
            getPlannedTasks();
        }
    }, [PlannedMaintenanceList.isTaskUpdated]);

    useEffect(() => {
        if (PlannedMaintenanceList.poolList?.length) {
            setPoolData(Object.values(PlannedMaintenanceList.poolList));
        }
    }, [PlannedMaintenanceList.poolList]);

    useEffect(() => {
        if (PlannedMaintenanceList.poolListByAssignedUser?.length) {
            setPoolDataByAssignedUser(Object.values(PlannedMaintenanceList.poolListByAssignedUser));
        }
    }, [PlannedMaintenanceList.poolListByAssignedUser]);

    const { shiftList } = useSelector(({ Shifts }) => Shifts);
    //load shift data
    let [shiftData, setShiftData] = useState([]);
    useEffect(() => {
        if (shiftList?.resultObject?.length > 0) {
            setShiftData(shiftList.resultObject[0].shifts);
        }
    }, [shiftList]);

    const { pm } = useSelector((PMstate) => PMstate);
    useEffect(() => {
        if (pm?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(pm.maintenanceType.resultObject);
        }
    }, [pm]);

    useEffect(() => {
        if (mainValue === 1) {
            HandleClearFilter();
        }
    }, [valueTasks, mainValue]);

    const handleChangeMainTabs = (event, newValue) => {
        // rapor dışı süre mi task mı
        setMainValue(newValue);
        ss.setItem("ap_selectedTab", newValue);
        setCurrentPage(0);
        if (newValue === 0) {
            getReportList();
            setValueTasks(0);
            ss.setItem("ap_selectedTabTasks", newValue);
        }
    };

    const handleChange = (event, newValue, pageSize = rowsPerPage) => {
        setValue(newValue);
        setCurrentPage(0);
        const payload = {
            pageNumber: 1,
            pageSize: pageSize,
            body: {
                reportStatuses: [newValue],
                sorting: {
                    propertyName: "id",
                    direction: 1,
                },
                areaId: parseInt(ss.getItem("ap_selectedAreaCode") ?? 0) ?? 0,
                machineId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
                poolIds: poolIds,
                assigneeIds: userIds || [],
            },
            firstCall: true,
        };
        dispatch(postUnplannedMaintenanceOfTheReports(payload));
    };

    const handleChangeTasks = (event, newValue) => {
        setValueTasks(newValue);
        ss.setItem("ap_selectedTabTasks", newValue);
        setCurrentPage(0);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const handleChangeIndexForTasks = (index) => {
        setValueTasks(index);
        ss.setItem("ap_selectedTabTasks", index);
    };

    const approveHandler = (id) => {
        let payload = {
            reportId: id,
            statusAction: "Approve",
        };
        dispatch(patchUnplannedMaintenanceOfTheReports(payload));
    };

    const rejectHandler = (id) => {
        let payload = {
            reportId: id,
            statusAction: "Reject",
        };
        dispatch(patchUnplannedMaintenanceOfTheReports(payload));
    };

    const closeHandler = (id) => {
        if (valueTasks === 0) {
            dispatch(closeUnPlannedMaintenance(id));
        }
        if (valueTasks === 1) {
            dispatch(closeManyPlannedTasks([id]));
        }
    };

    const closeManyHandler = () => {
        let ids = [];
        // set ids in first page
        rows.forEach((item) => {
            ids.push(item.id);
        });
        if (valueTasks === 0) {
            dispatch(closeManyUnplannedTasks(ids));
        }
        if (valueTasks === 1) {
            dispatch(closeManyPlannedTasks(ids));
        }
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
        if (mainValue === 0) {
            getReportList(newPage, rowsPerPage);
        }
        if (mainValue === 1) {
            if (valueTasks === 0) {
                getBreakdownTasks(newPage, rowsPerPage);
            }
            if (valueTasks === 1) {
                getPlannedTasks(newPage, rowsPerPage);
            }
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setCurrentPage(0);
        if (mainValue === 0) {
            getReportList(currentPage, event.target.value);
        }
        if (mainValue === 1) {
            if (valueTasks === 0) {
                getBreakdownTasks(currentPage, event.target.value);
            }
            if (valueTasks === 1) {
                getPlannedTasks(currentPage, event.target.value);
            }
        }
    };

    const redirectToDetail = (id) => {
        if (mainValue === 0) {
            history.push("breakdowndetail?id=" + id);
        }
        if (mainValue === 1) {
            if (valueTasks === 0) {
                history.push("breakdowndetail?id=" + id);
            } else if (valueTasks === 1) {
                history.push("/planned-maintenance-detail?id=" + id);
            }
        }
    };

    const [noteDetails, setNoteDetails] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const showNoteDetails = (row) => {
        setOpenDialog(true);
        setNoteDetails(row);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    // Machine popup
    const initialMachineStates = (isCleared = false) => {
        return {
            ssAbr: "ap",
            selectedAreaCode: isCleared ? null : ss.getItem("ap_selectedAreaCode") ?? null,
            selectedAreaName: isCleared ? null : ss.getItem("ap_selectedAreaName") ?? null,
            selectedMainEquipmentCode: isCleared ? null : ss.getItem("ap_selectedMainEquipmentCode") ?? null,
            selectedMainEquipmentName: isCleared ? null : ss.getItem("ap_selectedMainEquipmentName") ?? null,
            selectedSubEquipmentCode: isCleared ? null : ss.getItem("ap_selectedSubEquipmentCode") ?? null,
            selectedSubEquipmentName: isCleared ? null : ss.getItem("ap_selectedSubEquipmentName") ?? null,
        };
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);
    const HandleClearMachineStates = () => {
        ss.removeItem("ap_selectedAreaCode");
        ss.removeItem("ap_selectedAreaName");
        ss.removeItem("ap_selectedMainEquipmentCode");
        ss.removeItem("ap_selectedMainEquipmentName");
        ss.removeItem("ap_selectedSubEquipmentCode");
        ss.removeItem("ap_selectedSubEquipmentName");
        setMachineStates(initialMachineStates(true));
    };

    // Set pool
    const HandlePool = (poolName) => {
        let ids = [];
        poolName.map((item) => ids.push(item.id));
        setPoolIds(ids);
    };

    // Set start date
    const HandleStartDate = (date) => {
        if (date == null) {
            setStartDate(new Date());
        } else {
            setStartDate(date);
        }
    };

    const HandleBreakdownReasonGroup = (breakdownReasonGroup) => {
        let ids = [];
        breakdownReasonGroup.map((item) => ids.push(item.id));
        setBreakdownReasonGroupIds(ids);
    };

    const HandleShift = (shiftNo) => {
        let shiftIds = [];
        if (shiftNo != null) {
            shiftNo.map((item) => shiftIds.push(item.shiftNo));
            setShiftIds(shiftIds);
        }
    };

    //set user ınfo
    const HandleUser = (userName) => {
        const userInfo = userData.filter((item) => item.userName == userName);
        let userId = null;

        if (userInfo[0] != undefined) {
            // Filter if user exist
            userId = userInfo[0].id;
        }
        if (userName == null) {
            ss.removeItem("spl_userName");
            ss.removeItem("spl_user");
        } else {
            ss.setItem("spl_userName", userName);
            ss.setItem("spl_user", userId);
        }
        if (userId != null) {
            setUserIds([userId]);
            setUserName(userName);
        } else {
            setUserIds([]);
            setUserName("");
        }
    };

    // Maintenance Type
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState();
    const [selectedMaintenanceTypeIds, setSelectedMaintenanceTypeIds] = useState([]);
    const HandleMaintenanceTypeChange = (maintenanceName) => {
        if (maintenanceName !== null) {
            const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceName));
            setSelectedMaintenanceTypeName(filteredType[0].name);
            const filteredTypeIds = filteredType.map((item) => item.id);
            setSelectedMaintenanceTypeIds(filteredTypeIds);
        } else {
            setSelectedMaintenanceTypeName(null);
        }
    };

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        if (open) {
            if (mainValue === 0) {
                dispatch(getPoolByAssignedUser());
            }
            if (mainValue === 1) {
                dispatch(getReasonGroup());
                dispatch(getShifts());
                dispatch(getList());
                if (valueTasks === 1) {
                    dispatch(getMaintenanceType());
                }
            }
        }
        setIsFilterDrawerOpen(open);
    };

    const HandleApplyFilter = () => {
        if (valueTasks === 0) {
            getBreakdownTasks();
        }
        if (valueTasks === 1) {
            getPlannedTasks();
        }
        setIsFilterDrawerOpen(false);
    };

    const HandleClearFilter = () => {
        setPoolIds([]);
        setBreakdownReasonGroupIds([]);
        setShiftIds([]);
        setStartDate(new Date().getFullYear() - 1 + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate());
        setSelectedMaintenanceTypeName(null);
        setSelectedMaintenanceTypeIds([]);
        setIsFilterDrawerOpen(false);
        if (mainValue === 1) {
            if (valueTasks === 0) {
                const data = {
                    statusArr: [5].toString(),
                    assigneedIds: [],
                    creatorIds: [],
                    startDate: moment(startDate).format("YYYY-MM-DD"),
                    endDate: moment(new Date()).format("YYYY-MM-DD"),
                    breakdownGroupIds: [],
                    poolIds: [],
                    costCenterIds: [],
                    breakdownEffectIds: [],
                    areaGroupIds: [],
                    shifts: [],
                };
                let payload = {
                    data: data,
                    currentPage: currentPage,
                    pageSize: rowsPerPage,
                    firstCall: true,
                };
                dispatch(getUnPlannedMaintenanceListMultiple(payload));
            }
            if (valueTasks === 1) {
                const data = {
                    statusArr: [5].toString(),
                    assigneedIds: [],
                    creatorIds: [],
                    startDate: moment(startDate).format("YYYY-MM-DD"),
                    endDate: moment(new Date()).format("YYYY-MM-DD"),
                    maintenanceTypeIds: [],
                    poolIds: [],
                    costCenterIds: [],
                    areaGroupIds: [],
                    shifts: [],
                    sorting: {
                        propertyName: "id",
                        direction: 1,
                    },
                };
                let payload = {
                    data: data,
                    currentPage: currentPage,
                    pageSize: rowsPerPage,
                    firstCall: true,
                };
                dispatch(getPlannedMaintenanceListMultiple(payload));
            }
        }
    };

    const filter = () => {
        return (
            <DetailFilter
                HandlePool={HandlePool}
                poolIds={poolIds}
                poolData={poolData}
                HandleBreakdownReasonGroup={valueTasks === 0 ? HandleBreakdownReasonGroup : null}
                breakdownReasonGroup={valueTasks === 0 ? breakdownReasonGroupIds : null}
                breakdownReasonGroupData={valueTasks === 0 ? breakdownReasonGroupData : null}
                HandleStartDate={HandleStartDate}
                startDate={startDate}
                maxDate={valueTasks === 0 ? new Date() : null}
                HandleShift={HandleShift}
                shiftData={shiftData}
                shiftIds={shiftIds}
                HandleMaintenanceTypeChange={valueTasks === 1 ? HandleMaintenanceTypeChange : null}
                maintenanceTypes={valueTasks === 1 ? maintenanceTypes : null}
                selectedMaintenanceTypeName={valueTasks === 1 ? selectedMaintenanceTypeName : null}
            />
        );
    };

    const filterNonReportTime = () => {
        return (
            <DetailFilter
                HandlePool={HandlePool}
                poolIds={poolIds}
                poolData={poolDataByAssignedUser}
                setMachineStates={setMachineStates}
                machineStates={machineStates}
                HandleUser={HandleUser}
                userData={userData}
                userName={userName}
            />
        );
    };

    const HandleApplyFilterNonReportTime = () => {
        getReportList();
        setIsFilterDrawerOpen(false);
    };

    const HandleClearFilterNonReportTime = () => {
        setPoolIds([]);
        setUserIds([]);
        setUserName("");
        HandleClearMachineStates();
        setIsFilterDrawerOpen(false);
        const payload = {
            pageNumber: 1,
            pageSize: rowsPerPage,
            body: {
                reportStatuses: [value],
                sorting: {
                    propertyName: "id",
                    direction: 1,
                },
                areaId: 0,
                machineId: 0,
                poolIds: [],
                assigneeIds: [],
            },
            firstCall: true,
        };
        dispatch(postUnplannedMaintenanceOfTheReports(payload));
    };

    return (
        <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
            {mainValue === 1 ? (
                <>
                    <FilterDrawer
                        open={isFilterDrawerOpen}
                        onOpen={toggleDrawer(true)}
                        onClose={toggleDrawer(false)}
                        HandleClearFilter={HandleClearFilter}
                        HandleApplyFilter={HandleApplyFilter}
                        detailFilter={filter()}
                    />
                    <FilterButton onClick={() => toggleDrawer(true)} />
                </>
            ) : (
                <>
                    <FilterDrawer
                        open={isFilterDrawerOpen}
                        onOpen={toggleDrawer(true)}
                        onClose={toggleDrawer(false)}
                        HandleClearFilter={HandleClearFilterNonReportTime}
                        HandleApplyFilter={HandleApplyFilterNonReportTime}
                        detailFilter={filterNonReportTime()}
                    />
                    <FilterButton onClick={() => toggleDrawer(true)} />
                </>
            )}
            <Grid item style={{ marginTop: 10 }}>
                <Tabs value={mainValue} onChange={handleChangeMainTabs} variant="fullWidth" centered>
                    <Tab
                        style={{ display: "flex" }}
                        icon={
                            <IconButton id="ap_NonReportTime" aria-label="cart" sx={{ fontSize: 15 }}>
                                <Timelapse style={{ color: "#c5e1a5" }} />
                                <Typography id="ap_NonReportTimeText" variant="subtitle2" style={{ color: mainValue === 0 ? "#fff" : null, fontSize: 15, marginLeft: 5 }}>
                                    {t("NonReportTime")}
                                </Typography>
                            </IconButton>
                        }
                    />
                    <Tab
                        style={{ display: "flex" }}
                        icon={
                            <IconButton id="ap_MaintenanceLists" aria-label="cart">
                                <WorkOutline style={{ color: "#c5e1a5" }} />
                                <Typography id="ap_MaintenanceListsText" variant="subtitle2" style={{ color: mainValue === 1 ? "#fff" : null, fontSize: 15, marginLeft: 5 }}>
                                    {t("MaintenanceLists")}
                                </Typography>
                            </IconButton>
                        }
                    />
                </Tabs>
                <TabPanel value={mainValue} index={0}>
                    <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                        <Grid item>
                            <Tabs value={value} onChange={handleChange} variant="fullWidth" centered>
                                <Tab
                                    style={{ display: "flex" }}
                                    icon={
                                        <IconButton id="ap_AwaitingApproval" aria-label="cart">
                                            <Badge badgeContent={value === 0 ? count : null} color="warning" size="small">
                                                <TimerOutlined color="warning" style={count > 0 ? { marginRight: 15 } : null} />
                                            </Badge>
                                        </IconButton>
                                    }
                                    label={t("AwaitingApproval")}
                                />
                                <Tab
                                    style={{ display: "flex" }}
                                    icon={
                                        <IconButton id="ap_Rejects" aria-label="cart">
                                            <Badge badgeContent={value === 1 ? count : null} color="secondary" size="small">
                                                <RemoveDone color="secondary" style={count > 0 ? { marginRight: 15 } : null} />
                                            </Badge>
                                        </IconButton>
                                    }
                                    label={t("Rejects")}
                                />
                                <Tab
                                    style={{ display: "flex" }}
                                    icon={
                                        <IconButton id="ap_StatusApproved" aria-label="cart">
                                            <Badge badgeContent={value === 2 ? count : null} color="success" size="small">
                                                <DoneAll color="success" style={count > 0 ? { marginRight: 12 } : null} />
                                            </Badge>
                                        </IconButton>
                                    }
                                    label={t("StatusApproved")}
                                />
                            </Tabs>
                        </Grid>
                    </Grid>
                    {!isMobile && mainValue === 0 ? (
                        <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                            <Grid item style={{ marginTop: 10 }}>
                                <Paper elevation={3}>
                                    <TableContainer component={Paper}>
                                        <Table id="ap_Table" aria-label="simple table" sx={{ backgroundColor: value === 0 ? "#fff3e0" : value === 1 ? "#ffebee" : "#f1f8e9", color: "#f44336" }}>
                                            <TableHead id="ap_TableHead">
                                                <TableRow id="ap_TableRow">
                                                    <TableCell id="ap_TableTitleCell_Id" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("ID")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_TaskNo" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("TaskNo")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_MainEquipment" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("MainEquipment")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_SubEquipment" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("SubEquipment")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_Pool" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("Pool")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_Note" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("Note")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_Status" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("Status")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_SenderOfConsent" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("SenderOfConsent")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_AssigneeName" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("AssigneeName")}</Typography>
                                                    </TableCell>
                                                    {value === 0 ? (
                                                        <TableCell id="ap_TableTitleCell_Actions" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                            <Typography style={{ fontWeight: "bold" }}>{t("Actions")}</Typography>
                                                        </TableCell>
                                                    ) : null}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody id="ap_TableBody">
                                                {rows.map((row, index) => (
                                                    <TableRow id={`ap_TableRow_${index}`}>
                                                        <TableCell id="ap_TableCell_id" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.id}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_taskId" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.taskId}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_mainEquipmentName" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.mainEquipmentName?.length > 40 ? row.mainEquipmentName?.substring(0, 40) + "..." : row.mainEquipmentName}{" "}
                                                            {row.mainEquipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.mainEquipmentName)} /> : null}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_subEquipmentName" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.equipmentName?.length > 40 ? row.equipmentName?.substring(0, 40) + "..." : row.equipmentName}{" "}
                                                            {row.equipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.equipmentName)} /> : null}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_pool" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.poolName}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_note" align="center" style={{ color: "#212121" }}>
                                                            {row.note?.length > 40 ? row.note?.substring(0, 40) + "..." : row.note}{" "}
                                                            {row.note?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.note)} /> : null}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_status" align="center" onClick={() => redirectToDetail(row.taskId)}>
                                                            {value === 0 ? (
                                                                <Chip label={row.reportStatusDef} color="warning" icon={<TimerOutlined />} style={{ color: "#fff" }} />
                                                            ) : value === 2 ? (
                                                                <Chip label={row.reportStatusDef} color="success" icon={<DoneAll />} style={{ color: "#fff" }} />
                                                            ) : value === 1 ? (
                                                                <Chip label={row.reportStatusDef} color="secondary" icon={<RemoveDone />} style={{ color: "#fff" }} />
                                                            ) : null}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_creatorName" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.creatorName}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_assigneeName" align="center" onClick={() => redirectToDetail(row.taskId)} style={{ color: "#212121" }}>
                                                            {row.assigneeName}
                                                        </TableCell>
                                                        {value === 0 ? (
                                                            <TableCell id="ap_TableCell_action" align="center">
                                                                <IconButton
                                                                    id="ap_TableCell_4_Button_success"
                                                                    variant="contained"
                                                                    color="success"
                                                                    onClick={() => {
                                                                        approveHandler(row.id);
                                                                    }}
                                                                >
                                                                    <CheckCircleOutlineRounded fontSize="inherit" />
                                                                </IconButton>
                                                                <IconButton
                                                                    id="ap_TableCell_Button_1_error"
                                                                    variant="contained"
                                                                    color="error"
                                                                    onClick={() => {
                                                                        rejectHandler(row.id);
                                                                    }}
                                                                >
                                                                    <HighlightOffRounded fontSize="inherit" />
                                                                </IconButton>
                                                            </TableCell>
                                                        ) : null}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 20, 50]}
                                            component="div"
                                            count={count}
                                            rowsPerPage={rowsPerPage}
                                            page={currentPage}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </Paper>
                            </Grid>
                        </Grid>
                    ) : isMobile && mainValue === 0 ? (
                        <InfiniteScroll
                            id="ap_InfiniteScroll"
                            dataLength={rows.length} //This is important field to render the next data
                            next={FetchMoreData}
                            hasMore={hasMore}
                            loader={rows.length > 15 ? <LinearProgress id="bl_LinearProgress" /> : null}
                            endMessage={
                                rows.length === 0 ? (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("ThereIsNoRecord")}</b>
                                    </p>
                                ) : (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("YouHaveSeenItAll")}</b>
                                    </p>
                                )
                            }
                        >
                            <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Grid item style={{ marginTop: 10, width: "80%" }}>
                                    <SwipeableViews axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={value} onChangeIndex={handleChangeIndex}>
                                        <TabPanel value={value} index={0}>
                                            {rows.map((row, index) => (
                                                <Card
                                                    variant="outlined"
                                                    sx={{
                                                        display: "flex",
                                                        p: 1,
                                                        flexDirection: {
                                                            xs: "column", // mobile
                                                            sm: "row", // tablet and up
                                                        },
                                                        backgroundColor: "#fff3e0",
                                                        border: "3px solid #E76F51",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Box sx={{ alignSelf: "center", width: "100%", color: (theme) => (theme.palette.mode === "dark" ? "#212121" : "primary.700") }}>
                                                        <Grid id={`ap_Grid_${index}`} container>
                                                            <Grid id={`ap_Grid_${index}`} item xs={9} direction="column">
                                                                <Typography variant="body2">{row.creatorName}</Typography>
                                                                <Divider />
                                                                <Typography component="div">
                                                                    {row.mainEquipmentName?.length > 40 ? row.mainEquipmentName?.substring(0, 40) + "..." : row.mainEquipmentName}{" "}
                                                                    {row.mainEquipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.mainEquipmentName)} /> : null}
                                                                </Typography>
                                                                <Typography component="div">
                                                                    {row.equipmentName?.length > 40 ? row.equipmentName?.substring(0, 40) + "..." : row.equipmentName}{" "}
                                                                    {row.equipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.equipmentName)} /> : null}
                                                                </Typography>
                                                                <Typography component="div" fontWeight="bold">
                                                                    {row.note?.length > 40 ? row.note?.substring(0, 40) + "..." : row.note}{" "}
                                                                    {row.note?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.note)} /> : null}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid id={`ap_Grid_${index}`} item xs={3} direction="column" style={{ display: "flex", alignItems: "center" }}>
                                                                <Box
                                                                    id={`ap_Box_${index}`}
                                                                    pt={0}
                                                                    pr={1}
                                                                    pb={0}
                                                                    pl={1}
                                                                    borderRadius="20%"
                                                                    style={{ backgroundColor: "#F94144", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                    onClick={() => redirectToDetail(row.taskId)}
                                                                >
                                                                    <WhiteTextTypography id={`ap_Typg_${index}`} variant="subtitle1" align="center">
                                                                        {row.taskId}
                                                                    </WhiteTextTypography>
                                                                </Box>
                                                                <Grid container sx={{ justifyContent: "center" }}>
                                                                    <IconButton
                                                                        id={`ap_TableCell_Button_${index}`}
                                                                        variant="contained"
                                                                        color="success"
                                                                        onClick={() => {
                                                                            approveHandler(row.id);
                                                                        }}
                                                                        style={{ width: "35px" }}
                                                                    >
                                                                        <CheckCircleOutlineRounded fontSize="inherit" style={{ width: "35px" }} />
                                                                    </IconButton>
                                                                    <IconButton
                                                                        id={`ap_TableCell_Button_${index}`}
                                                                        variant="contained"
                                                                        color="error"
                                                                        onClick={() => {
                                                                            rejectHandler(row.id);
                                                                        }}
                                                                        style={{ width: "35px" }}
                                                                    >
                                                                        <HighlightOffRounded fontSize="inherit" style={{ width: "35px" }} />
                                                                    </IconButton>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Card>
                                            ))}
                                        </TabPanel>
                                        <TabPanel value={value} index={1}>
                                            {rows.map((row, index) => (
                                                <Card
                                                    variant="outlined"
                                                    sx={{
                                                        display: "flex",
                                                        p: 1,
                                                        flexDirection: {
                                                            xs: "column", // mobile
                                                            sm: "row", // tablet and up
                                                        },
                                                        backgroundColor: "#ffebee",
                                                        border: "3px solid #bf360c",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Box sx={{ alignSelf: "center", width: "100%", color: (theme) => (theme.palette.mode === "dark" ? "#212121" : "primary.700") }}>
                                                        <Grid id={`ap_Grid_${index}`} container>
                                                            <Grid id={`ap_Grid_${index}`} item xs={8} direction="column">
                                                                <Typography variant="body2">{row.creatorName}</Typography>
                                                                <Divider />
                                                                <Typography component="div">
                                                                    {row.mainEquipmentName?.length > 40 ? row.mainEquipmentName?.substring(0, 40) + "..." : row.mainEquipmentName}{" "}
                                                                    {row.mainEquipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.mainEquipmentName)} /> : null}
                                                                </Typography>
                                                                <Typography component="div">
                                                                    {row.equipmentName?.length > 40 ? row.equipmentName?.substring(0, 40) + "..." : row.equipmentName}{" "}
                                                                    {row.equipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.equipmentName)} /> : null}
                                                                </Typography>
                                                                <Typography component="div" fontWeight="bold">
                                                                    {row.note?.length > 40 ? row.note?.substring(0, 40) + "..." : row.note}{" "}
                                                                    {row.note?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.note)} /> : null}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid id={`ap_Grid_${index}`} item xs={4} direction="column" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <Box
                                                                    id={`ap_Box_${index}`}
                                                                    pt={0}
                                                                    pr={1}
                                                                    pb={0}
                                                                    pl={1}
                                                                    borderRadius="20%"
                                                                    style={{ backgroundColor: "#F94144", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                    onClick={() => redirectToDetail(row.taskId)}
                                                                >
                                                                    <WhiteTextTypography id={`ap_Typg_${index}`} variant="subtitle1" align="center">
                                                                        {row.taskId}
                                                                    </WhiteTextTypography>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Card>
                                            ))}
                                        </TabPanel>
                                        <TabPanel value={value} index={2}>
                                            {rows.map((row, index) => (
                                                <Card
                                                    variant="outlined"
                                                    sx={{
                                                        display: "flex",
                                                        p: 1,
                                                        flexDirection: {
                                                            xs: "column", // mobile
                                                            sm: "row", // tablet and up
                                                        },
                                                        backgroundColor: "#f1f8e9",
                                                        border: "3px solid #558b2f",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Box sx={{ alignSelf: "center", width: "100%", color: (theme) => (theme.palette.mode === "dark" ? "#212121" : "primary.700") }}>
                                                        <Grid id={`ap_Grid_${index}`} container>
                                                            <Grid id={`ap_Grid_${index}`} item xs={8} direction="column" >
                                                                <Typography variant="body2">{row.creatorName}</Typography>
                                                                <Divider />
                                                                <Typography component="div">
                                                                    {row.mainEquipmentName?.length > 40 ? row.mainEquipmentName?.substring(0, 40) + "..." : row.mainEquipmentName}{" "}
                                                                    {row.mainEquipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.mainEquipmentName)} /> : null}
                                                                </Typography>
                                                                <Typography component="div">
                                                                    {row.equipmentName?.length > 40 ? row.equipmentName?.substring(0, 40) + "..." : row.equipmentName}{" "}
                                                                    {row.equipmentName?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.equipmentName)} /> : null}
                                                                </Typography>
                                                                <Typography component="div" fontWeight="bold">
                                                                    {row.note?.length > 40 ? row.note?.substring(0, 40) + "..." : row.note}{" "}
                                                                    {row.note?.length >= 40 ? <FcInfo onClick={() => showNoteDetails(row.note)} /> : null}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid id={`ap_Grid_${index}`} item xs={4} direction="column" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <Box
                                                                    id={`ap_Box_1`}
                                                                    pt={0}
                                                                    pr={1}
                                                                    pb={0}
                                                                    pl={1}
                                                                    borderRadius="20%"
                                                                    style={{ backgroundColor: "#F94144", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                    onClick={() => redirectToDetail(row.taskId)}
                                                                >
                                                                    <WhiteTextTypography id={`ap_Typg_${index}`} variant="subtitle1" align="center">
                                                                        {row.taskId}
                                                                    </WhiteTextTypography>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Card>
                                            ))}
                                        </TabPanel>
                                    </SwipeableViews>
                                </Grid>
                            </Grid>
                        </InfiniteScroll>
                    ) : null}
                </TabPanel>
                <TabPanel value={mainValue} index={1}>
                    <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                        <Grid item style={{ marginTop: 10 }}>
                            <Tabs value={valueTasks} onChange={handleChangeTasks} variant="fullWidth" centered>
                                <Tab
                                    style={{ display: "flex" }}
                                    icon={
                                        <IconButton id="ap_BreakdownMaintenanceList" aria-label="cart">
                                            <Badge badgeContent={valueTasks === 0 ? count : null} color="warning" size="small">
                                                <Work style={count > 0 ? { marginRight: 15, color: "#ffe082" } : null} />
                                            </Badge>
                                        </IconButton>
                                    }
                                    label={t("BreakdownMaintenanceList")}
                                />
                                <Tab
                                    style={{ display: "flex" }}
                                    icon={
                                        <IconButton id="ap_PlannedList" aria-label="cart">
                                            <Badge badgeContent={valueTasks === 1 ? count : null} color="success" size="small">
                                                <WorkHistory style={count > 0 ? { marginRight: 15, color: "#b9f6ca" } : null} />
                                            </Badge>
                                        </IconButton>
                                    }
                                    label={t("PlannedList")}
                                    sx={{ fontSize: 15 }}
                                />
                            </Tabs>
                        </Grid>
                    </Grid>
                    <Grid container style={{ display: "flex", justifyContent: "end", alignItems: "end", width: "100%", flexWrap: "wrap" }}>
                        <Grid item style={{ marginTop: 10 }}>
                            <IconButton id="ap_CloseAll" aria-label="cart" sx={{ fontSize: 15 }} onClick={closeManyHandler}>
                                <CheckBox style={{ color: "#c5e1a5" }} />
                                <Typography variant="subtitle2" style={{ color: mainValue === 0 ? "#fff" : null, fontSize: 15, marginLeft: 5 }}>
                                    {t("CloseAll")}
                                </Typography>
                            </IconButton>
                        </Grid>
                    </Grid>
                    {!isMobile && mainValue === 1 ? (
                        <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", flexWrap: "wrap" }}>
                            <Grid item style={{ marginTop: 10 }}>
                                <Paper elevation={3}>
                                    <TableContainer component={Paper}>
                                        <Table id="ap_Table" aria-label="simple table" sx={{ backgroundColor: valueTasks === 0 ? "#fff3e0" : "#f1f8e9", color: "#f44336" }}>
                                            <TableHead id="ap_TableHead">
                                                <TableRow id="ap_TableRow">
                                                    <TableCell id="ap_TableTitleCell_1" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("ID")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_2" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("EquipmentDetailCode")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_3" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{valueTasks === 0 ? t("CallNote") : t("MaintenanceNote")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_4" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("WorkingNote")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_5" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("AssigneeName")}</Typography>
                                                    </TableCell>
                                                    <TableCell id="ap_TableTitleCell_6" align="center" style={{ fontSize: 15, fontWeight: "bold" }}>
                                                        <Typography style={{ fontWeight: "bold" }}>{t("Actions")}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody id="ap_TableBody">
                                                {rows.map((row, index) => (
                                                    <TableRow id={`ap_TableRow_${index}`}>
                                                        <TableCell id="ap_TableCell_id" align="center" onClick={() => redirectToDetail(row.id)} style={{ color: "#212121" }}>
                                                            {row.id}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_eqDetailCode" align="center" onClick={() => redirectToDetail(row.id)} style={{ color: "#212121" }}>
                                                            {row.equipmentDetailedCode}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_orderNote" align="center" style={{ color: "#212121" }}>
                                                            {row.orderNote?.length > 30 ? row.orderNote?.substring(0, 30) + "..." : row.orderNote}{" "}
                                                            {row.orderNote?.length >= 30 ? <FcInfo onClick={() => showNoteDetails(row.orderNote)} /> : null}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_note" align="center" style={{ color: "#212121" }}>
                                                            {row.notes?.length > 30 ? row.notes?.substring(0, 30) + "..." : row.notes}{" "}
                                                            {row.notes?.length >= 30 ? <FcInfo onClick={() => showNoteDetails(row.notes)} /> : null}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_assigneeName" align="center" onClick={() => redirectToDetail(row.id)} style={{ color: "#212121" }}>
                                                            {row.assigneeName}
                                                        </TableCell>
                                                        <TableCell id="ap_TableCell_action" align="center" style={{ color: "#212121" }}>
                                                            <IconButton
                                                                id={`ap_TableCell_4_Button_${index}`}
                                                                variant="contained"
                                                                color="success"
                                                                onClick={() => {
                                                                    closeHandler(row.id);
                                                                }}
                                                            >
                                                                <OfflinePin fontSize="inherit" />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[20, 50, 100]}
                                            component="div"
                                            count={count}
                                            rowsPerPage={rowsPerPage}
                                            page={currentPage}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </Paper>
                            </Grid>
                        </Grid>
                    ) : isMobile && mainValue === 1 ? (
                        <InfiniteScroll
                            id="ap_InfiniteScroll"
                            dataLength={rows.length} //This is important field to render the next data
                            next={FetchMoreData}
                            hasMore={hasMore}
                            loader={rows.length > 15 ? <LinearProgress id="bl_LinearProgress" /> : null}
                            endMessage={
                                rows.length == 0 ? (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("ThereIsNoRecord")}</b>
                                    </p>
                                ) : (
                                    <p style={{ textAlign: "center" }}>
                                        <b>{t("YouHaveSeenItAll")}</b>
                                    </p>
                                )
                            }
                        >
                            <Grid container style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Grid item style={{ marginTop: 10, width: "80%" }}>
                                    <SwipeableViews axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={valueTasks} onChangeIndex={handleChangeIndexForTasks}>
                                        <TabPanel value={valueTasks} index={0}>
                                            {rows.map((row, index) => (
                                                <Card
                                                    variant="outlined"
                                                    sx={{
                                                        display: "flex",
                                                        p: 1,
                                                        flexDirection: {
                                                            xs: "column", // mobile
                                                            sm: "row", // tablet and up
                                                        },
                                                        backgroundColor: "#fff3e0",
                                                        border: "3px solid #E76F51",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Box sx={{ alignSelf: "center", width: "100%", color: (theme) => (theme.palette.mode === "dark" ? "#212121" : "primary.700") }}>
                                                        <Grid id={`ap_Grid_${index}`} container>
                                                            <Grid id={`ap_Grid_${index}`} item xs={9} direction="column">
                                                                <Typography variant="body2">{row.assigneeName}</Typography>
                                                                <Typography component="div" fontWeight="bold">
                                                                    {row.equipmentDetailedCode?.length > 18 ? row.equipmentDetailedCode?.substring(0, 18) + "..." : row.equipmentDetailedCode}{" "}
                                                                    {row.equipmentDetailedCode?.length >= 18 ? <FcInfo onClick={() => showNoteDetails(row.equipmentDetailedCode)} /> : null}
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {t("CallNote")} {": "}
                                                                    {row.orderNote?.length > 30 ? row.orderNote?.substring(0, 30) + "..." : row.orderNote}{" "}
                                                                    {row.orderNote?.length >= 30 ? <FcInfo onClick={() => showNoteDetails(row.orderNote)} /> : null}
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {t("WorkingNote")} {": "}
                                                                    {row.notes?.length > 30 ? row.notes?.substring(0, 30) + "..." : row.notes}{" "}
                                                                    {row.notes?.length >= 30 ? <FcInfo onClick={() => showNoteDetails(row.notes)} /> : null}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid id={`ap_Grid_${index}`} item xs={3} direction="column" style={{ display: "flex", alignItems: "center" }}>
                                                                <Box
                                                                    id={`ap_Box_${index}`}
                                                                    pt={0}
                                                                    pr={1}
                                                                    pb={0}
                                                                    pl={1}
                                                                    borderRadius="20%"
                                                                    style={{ backgroundColor: "#F94144", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                    onClick={() => redirectToDetail(row.id)}
                                                                >
                                                                    <WhiteTextTypography id={`ap_Typg_${index}`} variant="subtitle1" align="center">
                                                                        {row.id}
                                                                    </WhiteTextTypography>
                                                                </Box>
                                                                <IconButton
                                                                    id={`ap_TableCell_4_Button_${index}`}
                                                                    variant="contained"
                                                                    color="success"
                                                                    onClick={() => {
                                                                        closeHandler(row.id);
                                                                    }}
                                                                >
                                                                    <OfflinePin fontSize="inherit" />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Card>
                                            ))}
                                        </TabPanel>
                                        <TabPanel value={valueTasks} index={1}>
                                            {rows.map((row, index) => (
                                                <Card
                                                    variant="outlined"
                                                    sx={{
                                                        display: "flex",
                                                        p: 1,
                                                        flexDirection: {
                                                            xs: "column", // mobile
                                                            sm: "row", // tablet and up
                                                        },
                                                        backgroundColor: "#ffebee",
                                                        border: "3px solid #bf360c",
                                                        marginTop: "5px",
                                                    }}
                                                >
                                                    <Box sx={{ alignSelf: "center", width: "100%", color: (theme) => (theme.palette.mode === "dark" ? "#212121" : "primary.700") }}>
                                                        <Grid id={`ap_Grid_${index}`} container>
                                                            <Grid id={`ap_Grid_${index}`} item xs={9} direction="column">
                                                                <Typography variant="body2">{row.assigneeName}</Typography>
                                                                <Typography component="div" fontWeight="bold">
                                                                    {row.equipmentDetailedCode?.length > 18 ? row.equipmentDetailedCode?.substring(0, 18) + "..." : row.equipmentDetailedCode}{" "}
                                                                    {row.equipmentDetailedCode?.length >= 18 ? <FcInfo onClick={() => showNoteDetails(row.equipmentDetailedCode)} /> : null}
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {t("MaintenanceNote")} {": "}
                                                                    {row.orderNote?.length > 30 ? row.orderNote?.substring(0, 30) + "..." : row.orderNote}{" "}
                                                                    {row.orderNote?.length >= 30 ? <FcInfo onClick={() => showNoteDetails(row.orderNote)} /> : null}
                                                                </Typography>
                                                                <Typography variant="body2">
                                                                    {t("WorkingNote")} {": "}
                                                                    {row.notes?.length > 30 ? row.notes?.substring(0, 30) + "..." : row.notes}{" "}
                                                                    {row.notes?.length >= 30 ? <FcInfo onClick={() => showNoteDetails(row.notes)} /> : null}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid id={`ap_Grid_${index}`} item xs={3} direction="column" style={{ display: "flex", alignItems: "center" }}>
                                                                <Box
                                                                    id={`ap_Box_${index}`}
                                                                    pt={0}
                                                                    pr={1}
                                                                    pb={0}
                                                                    pl={1}
                                                                    borderRadius="20%"
                                                                    style={{ backgroundColor: "#F94144", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                    onClick={() => redirectToDetail(row.id)}
                                                                >
                                                                    <WhiteTextTypography id={`ap_Typg_${index}`} variant="subtitle1" align="center">
                                                                        {row.id}
                                                                    </WhiteTextTypography>
                                                                </Box>
                                                                <IconButton
                                                                    id={`ap_TableCell_4_Button_${index}`}
                                                                    variant="contained"
                                                                    color="success"
                                                                    onClick={() => {
                                                                        closeHandler(row.id);
                                                                    }}
                                                                >
                                                                    <OfflinePin fontSize="inherit" />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Card>
                                            ))}
                                        </TabPanel>
                                    </SwipeableViews>
                                </Grid>
                            </Grid>
                        </InfiniteScroll>
                    ) : null}
                </TabPanel>
            </Grid>
            <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="md_DialogTitle">{t("Information")}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="md_DialogDesc" style={{ overflow: "hidden", wordWrap: "break-word" }}>
                        {noteDetails}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            {isMobile ? (
                <ScrollTop
                    text="▲"
                    distance={100}
                    breakpoint={2000}
                    style={{ backgroundColor: "#BCC5C6", borderRadius: "20px", border: "2px", color: "black" }}
                    speed={200}
                    target={0}
                    number={10}
                    icon={<ArrowDropUp />}
                />
            ) : null}
            <LoadingBackdrop id="bd_lbd" />
        </Grid>
    );
}
